import useRequestSearch from "../result/useRequestSearch";

export interface RequestSearchInitializerProps {
	namespace: string;
	showResultsOnInitialPageLoad: boolean;
	searchesEnabled: boolean;
}

export const RequestSearchInitializer = ({
	namespace,
	showResultsOnInitialPageLoad,
	searchesEnabled,
}: RequestSearchInitializerProps) => {
	useRequestSearch(namespace, showResultsOnInitialPageLoad, searchesEnabled);

	return null;
};